<template>
  <div>
    <div v-if="isSamePerson(msg)" class="chat__mymessage" :class="[isSame ? '' : 'chat__first']">
      <p class="chat__mymessage__paragraph">{{ msg.message }}
        <span class="chat__yourmessage__time chat__mymessage_time">{{ msg.time }}</span>
      </p>
    </div>
    <div v-else-if="msg.type === 'info'">
      <el-divider content-position="left">{{ msg.message }}</el-divider>
    </div>
    <div v-else class="chat__yourmessage" :class="[isSame ? '' : 'chat__first']">
      <div>
        <div class="chat__yourmessage__p">
          <p class="chat__yourmessage__paragraph">
            <span class="chat__yourmessage__user" v-if="!isSame">{{ msg.username }}</span>
            <br>
            {{ msg.message }}
            <span class="chat__yourmessage__time">{{ msg.time }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["msg", "prev", "userId"],
  data() {
    return {
      isSame: false,
    };
  },
  methods: {
    isSamePerson(msg) {
      console.log('item', msg, this.userId)
      return msg.userId === this.userId;
    },
  },
  created() {
    this.isSame = this.isSamePerson(this.msg);
  },
};
</script>

<style>
.chat__mymessage_time {
  color: rgb(255, 255, 255) !important;
  margin-left: 20px;
}

.chat__mymessage {
  display: flex;
  justify-content: right;
  align-items: flex-end;
  margin: 0;
  min-height: 40px;
  line-break: anywhere;
}

.chat__mymessage__paragraph {
  margin-right: 20px;
  border-radius: 20px 20px 0px 20px;
  max-width: 380px;
  width: 380px;
  background-color: #bbc4ef;
  color: #ffffff;
  padding: 0.8rem;
  font-size: 14px;
}

.chat__yourmessage {
  display: flex;
}

.chat__yourmessage__avartar {
  width: 40px;
  margin-right: 1rem;
}

.chat__yourmessage__img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.chat__yourmessage__user {
  font-size: 12px;
  font-weight: 700;
  color: #292929;
  margin-top: 0;
  margin-block-end: 0rem;
}

.chat__yourmessage__p {
  display: flex;
  align-items: flex-end;
  line-break: anywhere;
}

.chat__yourmessage__paragraph {
  margin: 0.4rem 0.4rem 0 0;
  border-radius: 0px 20px 20px 20px;
  background-color: #f3f3f3;
  max-width: 380px;
  width: 380px;
  color: #414141;
  padding: 5px 20px 5px 10px;
  font-size: 12px;
}

.chat__yourmessage__time {
  font-size: 10px;
  color: #9c9c9c;
  position: relative;
  display: block;
  float: right;
  margin-top: 12px;
}
</style>